module.exports = __webpack_public_path__ + "assets/images/news-header-18d430d563cdc86621c260d0732aedf6.jpg";